
import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import './Download.scss';
import DownloadBtn from './DownloadBtn';
const Download = () => {
const { data, current_doc } = useSelector((state) => state.data);
const [docs]=useState(data?.popupUrls);
  return (
    <div className='download_form'>
      {docs.map((doc)=>(
        <DownloadBtn label={doc.label} link={doc.link}/>
      ))}
    </div>
  )
}

export default Download




